import { useForm } from 'react-hook-form';
import {
  buildFormSchema,
  FormData,
  PartApplicationFormInput,
} from '../validation/formSchema';
import { zodResolver } from '@hookform/resolvers/zod';
import { PartyApplicationState } from '../../../types/PartyApplication/partyApplication';

export const usePartApplicationForm = (
  initialData?: Partial<PartApplicationFormInput> | null,
  requiredConsentIds: string[] = [],
  pageTexts?: PartyApplicationState['pageTexts']
) => {
  const schema = buildFormSchema(requiredConsentIds, pageTexts);

  return useForm<PartApplicationFormInput, unknown, FormData>({
    resolver: zodResolver(schema),
    defaultValues: { terminatedEmployees: [], ...initialData },
    mode: 'onChange',
    reValidateMode: 'onChange',
  });
};
